import styled from "styled-components";
import { colors } from "../../../components/common/element/elements";

export const Styles = styled.div`
  .dmu-english-exam-section {
    padding: 32px 0;

    .info {
      margin-bottom: 24px;
      border-left: 4px solid ${colors.bg1};
      padding-left: 16px;
      border-radius: 4px;
    }

    ul {
      padding: 12px 0;
      li {
        display: flex;
        column-gap: 10px;
        border-radius: 8px;
        box-shadow: 0 1px 10px 5px rgb(0 0 0 / 3%);
        padding: 10px 15px;
        font-size: 15px;
        color: ${colors.text3};
        line-height: 25px;
        margin-bottom: 15px;
      }

      li.item {
        i {
          color: ${colors.bg1};
          font-size: 20px;
        }
      }
    }

    .structure {
      margin-top: 32px;
      .structure-list {
        padding-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        flex-wrap: wrap;
        .structure-item {
          border-radius: 8px;
          box-shadow: 0 1px 10px 5px rgb(0 0 0 / 3%);
          padding: 24px;
          font-size: 15px;
          width: 360px;
          height: 260px;
          color: ${colors.text3};
          line-height: 25px;
          margin-bottom: 15px;
        }
      }
    }

    .details {
      .address {
        margin-top: 24px;
        margin-bottom: 32px;
        font-size: 16px;
        color: ${colors.text3};
        line-height: 24px;
        padding-left: 12px;
        border-left: 4px solid ${colors.bg1};
        border-radius: 4px;
      }
    }
    a {
      color: ${colors.bg2};
      &:hover {
        text-decoration: underline;
      }
    }

    .guidelines {
      a {
        text-decoration: none;
      }
    }
  }

  .register-button-link {
    display: flex;
    align-items: center;
    background-color: #662a30;
    color: #fff !important;
    border: none;
    border-radius: 8px;
    padding: 8px 30px;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    &:hover {
      background-color: #d3ae6e;
    }
  }

  table {
    margin: 24px 0 48px;
    overflow-x: auto !important;
    width: 100% !important;
  }

  th,
  td {
    padding: 12px 24px;
    vertical-align: middle !important;
  }

  th {
    background-color: #f2f2f2;
    font-weight: 600;
    text-align: center;
  }

  td {
    text-align: center;
    &:first-child {
      white-space: pre-wrap;
    }
  }

  @media (max-width: 768px) {
    .dmu-english-exam-section {
      padding: 24px 0;
    }
    table {
      font-size: 14px;
    }
    th,
    td {
      padding: 4px 8px;
    }
  }
`;
